<template>
  <v-container>
    <v-dialog v-model="openFlag" max-width="600px" persistent>
      <c-card class="white" :title="resultBulkUploadType === 'new'? '일괄등록': '일괄등록(업데이트)'">
        <v-row justify="center" class="my-4">
          <div>총 <span class="red--text">{{resultBulkData? resultBulkData.totalCnt: ""}}</span>건 중
            <span class="red--text">{{resultBulkData? (resultBulkData.totalCnt - resultBulkData.failureCnt): ""}}</span> 건을 {{resultBulkUploadType === 'new'? '등록': '갱신'}} 완료하였습니다.</div>
        </v-row>
        <v-row align="end">
          <div>실패 목록</div>
          <v-spacer></v-spacer>
          <c-btn color="grey" outlined :disabled="downloadFileFlag" @click="downloadFailedData">누락 데이터 내려받기</c-btn>
          <c-scroll-table
            :headers="failedDataHeaders"
            :items="showFailedData"
            height="400"
            @loadMore="onLoadDataMore"
          />
        </v-row>
        <v-row justify="center">
          <c-btn class="blue" @click="openFlag = false">확인</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
      resultBulkUploadType: { // 'new' || 'update'
        type: String,
        default: 'new'
      },
      resultBulkData: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        openFlag: false,

        pageNum: 1,
        perPage: 50,
        endIdx: 0,
        showFailedData: [],
        failedData: null,
        failedDataHeaders: [
          {text: '행 번호', value: 'rowNum', align: 'center', sortable: false},
          {text: '실패 사유', value: 'cause', align: 'center', sortable: false}
        ]
      }
    },
    computed: {
      downloadFileFlag() {
        if(this.resultBulkData && this.resultBulkData.failedDataFileName) return false;
        return true;
      }
    },
    methods: {
      onLoadDataMore() {
        if(this.failedData && this.failedData.length > 0 && this.endIdx < this.failedData.length) {
          const startIdx = (this.pageNum-1) * this.perPage;
          let endIdx = startIdx + this.perPage;
          if(endIdx > this.failedData.length)
            endIdx = this.failedData.length;

          this.pageNum++;
          this.endIdx = endIdx;
          this.showFailedData = this.failedData.slice(0, endIdx);
        }
      },
      downloadFailedData() {
        this.$emit('downloadFailedData', this.resultBulkData.failedDataFileName);
      }
    },
    watch: {
      open(newVal) {
        if(newVal) {
          // 데이터 초기화
          this.pageNum = 1;
          this.endIdx = 0;
          this.showFailedData = [];

          // result data 정제
          if(this.resultBulkData && this.resultBulkData.failedData) {
            const failedData = this.resultBulkData.failedData;
            // 서버에서 올라온 행번호 시작은 0부터, 보여질 행번호는 + 1
            this.failedData = Object.keys(failedData).map(key => {return {rowNum: (parseInt(key)+1), cause: failedData[key]};} );
            this.onLoadDataMore();
          } else {
            this.failedData = null;
          }
          this.openFlag = newVal;
        }
      },
      openFlag(newVal) {
        if(newVal) {
        } else {
          this.$emit('update:open', false);
        }
      }
    },
  }
</script>

<style scoped>

</style>
